module.exports = "<div class=lazy-autocomplete> <input show-result=$ctrl.showResult close-on-blur ng-model=$ctrl.search ng-focus=\"$ctrl.showResult = true\" type=text> <div class=result ng-if=$ctrl.showResult> <ul> <li ng-click=\"item.IsSelected = true\" ng-repeat=\"item in $ctrl.items | filter:$ctrl.notSelected() | filter:$ctrl.search\"> {{item.Value}} <icon ng-if=item.ExtValue ng-style=\"{'background-image':'url({{item.ExtValue}})'}\"></icon> </li> </ul> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/lazy-autocomplete/lazy-autocomplete.component.html
// module id = 34
// module chunks = 1 3